import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../axios/axiosInstance";

export const key = ["STOCK_COUNT"];
export const useGetStockCount = (roles) => {
  const isAdmin = roles?.some((role) => role.name === "chat-admin");
  return useQuery(
    key,
    async () => {
      const { data } = await axiosInstance.get(
        `admin/messages/conversations?category=stock&per_page=1`
      );
      return data.meta.total;
    },
    {
      enabled: isAdmin,
      staleTime: Infinity,
    }
  );
};
